import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import styled from 'styled-components';
import smoothScroll from "../../utility/smoothScroll";

const fullScreen = window.navigator.standalone;
const theHeight = fullScreen ? 'calc(-100vh + 200px);' : 'calc(-100vh + 200px)';

const CrewStyled = styled.div`
    background-color: ${({ theme }) => theme.colors.primary };
    color: ${({ theme }) => theme.colors.secondary };
    left: 0;
    height: calc(100vh - 50px);
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 10;
    
    @media(min-width: 769px) {
      top: auto;
      height: 50px;
      bottom: 0;
    }
    
    li {
      display: inline-block;
      margin: 0 20px;
    }

    &.is-mobile {
      transform: translate3d(0, calc(-100vh + 100px) ,0 );

      ul {
        padding: 0;
      }
      
      li {
        margin: 0;
        padding: 20px 0;
        text-align: center;
        width: 100%;
      }
    }
    
    &.is-mobile.is-enabled {
      transform: translate3d(0, 0, 0 );
    }
    
    .mobile-expander {
      position: absolute;
      bottom: 10px;
      right: 10px;
      transform: rotate(180deg);
    }
    
    @media (max-width: 769px) {
      top: 50px;
    }
    
    &.crew-menu {
      a {
      color: white;
    }
    
    .is-active-menu {
        color: white;
      }
    }
    
    &.crew-menu--tertiary {
      background-color: transparent;
      position: relative;
      top: auto;
      left: auto;
      
      ul {
      padding: 0;
      }
      
      a {
        color: ${({ theme }) => theme.colors.primary };
      }
      
      .is-active-menu {
        color: ${({ theme }) => theme.colors.primary };
        border-bottom-color: ${({ theme }) => theme.colors.primary };
      }
   
    }
`;

  const Meet = styled.div`
    bottom: 10px;
    position: absolute;
    text-align: center;
    width: 100%;
    
    @media (max-width: 640px) {
      font-size: 20px;
    }
  `;

  const Address = styled.div`
    position: absolute;
    right: 20px;
    top: 16px;
`

class CrewMenu extends React.Component {

  state = {};

  componentDidMount() {
    this.setState(() => ({ enabled: false }))
  }

  render() {
    const { allStories, handleClick, isMobile, title, highlight } = this.props;
    const classNames = {
      [this.props.className]: true,
      'is-mobile': isMobile,
      'is-enabled': this.state.enabled,
      'crew-menu': true,
      highlight: highlight && !isMobile
    };

    return (
        <CrewStyled className={ classnames(classNames) }>
          { isMobile &&
              <div onClick={ () => { this.setState(() => ({ enabled: !this.state.enabled })) } } className="mobile-expander">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path fill="#ffffff" d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/>
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </div>
          }
          <ul>
            { allStories.sort((a,b) => (Number(a.order) > Number(b.order)) ? 1 : ((Number(b.order) > Number(a.order)) ? -1 : 0)).map((story, index) =>
                <li onClick={ () => { this.setState(() => ({ enabled: false })); } } style={ { } } key={ index }>
                  <NavLink activeClassName='is-active-menu' onClick={ handleClick } to={`/${story.section}/${story.path}` }>
                    { story.name ? story.name : story.title }
                  </NavLink>
                </li>)
            }
          </ul>
          { isMobile &&
          <Meet onClick={ () => { this.setState(() => ({ enabled: !this.state.enabled })) } } className="crew-menu-title">{ title }</Meet> }
        </CrewStyled>
    );
  }
}

CrewMenu.propTypes = {
  allStories: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default CrewMenu;



// WEBPACK FOOTER //
// ./src/components/CrewMenu/CrewMenu.js